export function isClient(user: unknown): user is Client {
  if (typeof user !== "object" || user === null) return false;
  return "identification" in user;
}

export function isNotary(user: unknown): user is Notary {
  if (typeof user !== "object" || user === null) return false;
  return "username" in user;
}
